import React, { useEffect, useState } from "react";
import "./App.css";
import {BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./function-components/PageLayout";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { TabProvider } from "./TabContext";
import { BASE_API_URL } from "./utils/constants";
import PrivateRoute from "./ProtectedRoute"
import AccessDenied from './AccessDenied';
import TokenValidator from "./TokenValidity";
import ManageTracks from "./function-components/ManageTracks/ManageTracks";
import SelfPacedTabs from "./function-components/SelfPaced/SelfPacedTabs";
import SelfHomeContent from "./function-components/SelfPaced/SelfHome";
import ApproveNominations from "./function-components/ApproveNominations/ApproveNominations";
import { updateLoginUserName } from "./Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";
import { fetchAdminUser } from "./function-components/Redux/AdminUserSlice";
import Track from "./function-components/Track";
import SessionDetailsToNominateTabs from "./function-components/BusinessPOC/SessionDetailsToNominateTabs";

import About from "./function-components/About";

import BundleSkills from "./BundleSkills";
import RecommendTrainings from "./BundleSkills/RecommendedTrainings";
import ApproveBundleSkillNominations from "./BundleSkills/ApproveNominations";
import THBundleSkills from "./BundleSkills/THtabs";
import THContent from "./function-components/TH/THContent";
import TH from "./BundleSkills/THtabs";
import DeliveryLeadership from "./pages/DeliveryLeadership";


const baseURL = BASE_API_URL;
function App({ pca }) {
 
 return (
  <MsalProvider instance={pca}>
   <PageLayout>
    <div container justifyContent="center">
     <Pages pca= {pca}/>
    </div>
   </PageLayout>
  </MsalProvider>
 );
}
function Pages({ pca }) {
 const msalInstance = new PublicClientApplication(msalConfig);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const dispatch = useDispatch();
 const navigate = useNavigate();

  useEffect(() => {
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);
  }, [navigate, pca]);

 useEffect(() => {
  if (activeAccount) {
   fetchAccessToken();
   dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
   dispatch(fetchAdminUser(activeAccount.idTokenClaims.enterpriseID)); 
  }
 }, [activeAccount]);

const fetchAccessToken = async () => {
  if (!activeAccount)
   throw Error(
    "No active account! Verify a user has been signed in and setActiveAccount has been called."
   );
  try {
   const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: activeAccount,
   });
   const bearer = `Bearer ${response.accessToken}`;
   localStorage.setItem("token", bearer);
  } catch (error) {
   console.error("Error fetching access token:", error);
   localStorage.clear();
  }
 };

 return (
  <>
  <TabProvider>
  <TokenValidator />
    <SearchNav />
    <Routes>
       <Route path="/" element={<Home/>} />
      <Route path="/bundleSkills" element={<BundleSkills/>}>
        <Route path="recommended-trainings" element={<RecommendTrainings/>}/>
        <Route index element={<RecommendTrainings/>} /> 
        <Route path="th" element={<TH/>}/>
      </Route>
      <Route path="/access-denied" element={<AccessDenied />}  />
       <Route
            path="/delivery-leadership/*"
            element={<DeliveryLeadership />}
          />
          <Route
            path="/manageTracks"
            element={
              <PrivateRoute>
                <ManageTracks />
              </PrivateRoute>
            }
          />
    </Routes>
    <Footer/>
  </TabProvider>
  </>
 );
}

export default App;